import { default as emotionStyled } from '@emotion/styled'
import { MediaQueries, ThemeProps } from '@hhgtech/hhg-components'
import styled from 'styled-components'

import { parsedContentStyle } from '../components/index.styled'

export const StyledBabyPoopIntroduce = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  ${MediaQueries.mbUp} {
    gap: 40px;
  }
`

export const StyledBabyPoopIntroduceMainColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
`
export const StyledBabyPoopIntroduceSubColumn = styled.div``

export const StyledBabyPoopList = styled.div`
  padding: 40px 0;
`

export const StyledBabyPoopListDescription = emotionStyled.div`
  border-radius: ${(props) => props.theme?.radius.lg}px;
  background: ${(props) => props.theme?.colors?.lightGray};
  padding: 12px;

  ${parsedContentStyle}
`

export const StyledBabyPoopContentWarning = emotionStyled.div`
  background-color: ${(props) => props.theme?.colors.toneYellow};
  border-radius: 2px;
  display: flex;
  align-items: center;
  padding: 8px;
  gap: 12px;

  svg {
    flex-shrink: 0;
  }
`

export const StyledBabyPoopListGrid = styled.div`
  display: grid;
  ${MediaQueries.mbUp} {
    grid-gap: 24px;
    grid-template-columns: 1fr 1fr;
  }

  ${MediaQueries.mbDown} {
    grid-gap: 16px;
    grid-template-columns: 1fr;
  }
`
export const StyledGuideline = emotionStyled.div`
display: flex;
flex-direction: column;
gap:12px;
`
export const StyledContent = emotionStyled.div`
display: flex;
flex-direction: column;
gap:24px;
`

export const StyledBreadCrumbsContainer = styled.div`
  &.lightpink {
    background-color: ${(props: ThemeProps) => props.theme.mbColors.lightPink};
  }

  .breadcrumbs {
    padding: 24px 16px;
  }

  ${MediaQueries.mbDown} {
    .breadcrumbs {
      padding: 16px 0;
    }
  }
`
